import { render, staticRenderFns } from "./DataBankTab.vue?vue&type=template&id=6f8f3a86&scoped=true&"
import script from "./DataBankTab.vue?vue&type=script&lang=js&"
export * from "./DataBankTab.vue?vue&type=script&lang=js&"
import style0 from "./DataBankTab.vue?vue&type=style&index=0&id=6f8f3a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f3a86",
  null
  
)

export default component.exports